import { Button, Flex, Image } from 'antd'
import { t } from 'i18next'
import _ from 'lodash'
import React from 'react'
import AvailableNowCard from '../AvailableNowCard'
import PublicSiderXS from '../../Layouts/Sider/PublicSiderXS'

export default function TabletBoxSlotList ({ box, daysList, more }) {
  return (
    <>
      <PublicSiderXS />
      <Flex vertical align='center' style={{ textAlign: 'center', margin: '0 5em' }}>
        {
            box && box.waiting_time_url &&
            <Image
              width={'50em'}
              src={box.waiting_time_url.url}
            />
        }
        {
          box && box['available_now?'] &&
          <AvailableNowCard box={box} />
        }
        {daysList}
        <Button style={{ marginTop: '2em' }} onClick={more} type="primary">{t('Public.BoxPage.more')}</Button>
      </Flex>
    </>
  )
}
